<script setup>
import { useI18n } from 'vue-i18n';

defineProps({ busy: { type: Boolean, default: false } });
const baseUrl = defineModel('baseUrl', { type: String, default: '' });
const token = defineModel('token', { type: String, default: '' });
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-3">
    <label class="flex flex-col gap-1 text-sm text-n-slate-12">
      {{ t('INBOX_MGMT.EDIT.HYBRID_QR.OPTION_MANUAL.URL') }}
      <input
        v-model="baseUrl"
        type="url"
        autocomplete="off"
        :disabled="busy"
        class="mb-0 w-full bg-n-solid-2"
      />
    </label>
    <label class="flex flex-col gap-1 text-sm text-n-slate-12">
      {{ t('INBOX_MGMT.EDIT.HYBRID_QR.OPTION_MANUAL.TOKEN') }}
      <input
        v-model="token"
        type="password"
        autocomplete="new-password"
        :disabled="busy"
        :placeholder="t('INBOX_MGMT.EDIT.HYBRID_QR.OPTION_MANUAL.TOKEN_HINT')"
        class="mb-0 w-full bg-n-solid-2"
      />
    </label>
  </div>
</template>
